import template from "./AdminFeedback.html";
import { saveFeedback } from "./util";
import * as icons from "./icons.json";

export default {
  template: template,
  props: ["feedback", "person"],
  data: function () {
    return {
      icons: icons,
    };
  },
  methods: {
    format_time(timestamp) {
      // Parse the timestamp correctly - it could be a string or a number
      const ts = parseInt(timestamp, 10);
      if (isNaN(ts)) {
        return "Unknown date";
      }
        // return as day (2023-10-01), use strftime
      return new Date(ts * 1000).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    saveFeedback() {
      saveFeedback(this.feedback);
    },
    async checkFeedback() {
      try {
        const ok = await saveFeedback(this.feedback);
        if (!ok) {
          throw new Error();
        }
      } catch (err) {
        console.log("checkFeedback failed", err);
        this.feedback.checked = false;
      }
    },
    icon() {
      const icon = this.icons[this.feedback.icon];
      if (icon) {
        return icon.emoji;
      }
      // sometimes there's no icon because it's overall feedback
      return "";
    },
    deleteFeedback() {
      this.feedback.deleted = true;
      this.saveFeedback();
    },
    toggleStar() {
      this.feedback.starred = !this.feedback.starred;
      this.saveFeedback();
    },
  },
};
